import styled from "styled-components";
import eyeIcon from '../../images/icon-eye.png';

export const FormMainBlock = styled.div`
  padding-top: 2.5rem;
  min-height: calc(100vh - 17.5rem);

  section {
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
    border-top: 1px solid rgba(166, 189, 189, 0.7);
    border-bottom: 1px solid rgba(166, 189, 189, 0.7);
  }
  @media(max-width:450px){
    min-height: auto;
    section {
      padding-top: 3.25rem;
      padding-bottom: 3.25rem;
    }
  }

  .div__container {
    display: flex;
    justify-content: center;

    .div__form {
      width: 41.66666667%;

      h3 {
        margin-bottom: 2.5rem;
        font-size: 2.25rem;
        line-height: 1.2;
        text-align: center;
      }

      .form__content {
        max-width: 31.25rem;
        margin-left: auto;
        margin-right: auto;
      }
    }

    @media(max-width:880px){
      .div__form {
      width: 100%;
      }
    }
  }
`;

export const ArticleBlock = styled.article`
  margin-bottom: 2rem;

  .div__main__block {
    position: relative;
  }

  .input__styles {
    width: 100%;
    border: 1px solid rgba(229, 238, 238, 0.992);
    color: #232c42;
    text-align: center;
    border-radius: 2px;
    background-color: #fff;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.25rem;
    padding: 17px 47px 17px 47px;
  }

  .form__req__info {
    font-weight: 300;
    font-size: 0.875rem;
    position: absolute;
    bottom: -35%;
    left: 50%;
    color: #eb5757;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .phone__label{
    @media(max-width:415px){
      bottom: -25%;
    }
  }
`;

export const TheLine = styled.div`
  padding: 1.875rem 0 1.875rem 0;

  span {
    display: block;
    border-top: 1px solid rgba(35, 44, 66, 0.1);
  }
`;

export const ShowPasswordBlock = styled.div`
  position: absolute;
  top: 50%;
  right: 1.625rem;
  transform: translateY(-50%);
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;

  span {
    background: url(${eyeIcon}) no-repeat center center;
    width: 100%;
    height: 100%;
    display: block;
    transition: filter 0.3s ease;
  }

  &:hover span {
    filter: brightness(0) invert(0.5);
  }
`;
